// Issue #118 — the evidence module: a unified append-only ledger every engine
// writes to, and a merge-time provenance receipt (in-toto + DSSE + AI-BOM)
// projected from it, graded by evidence strength so it can't be theater.

export * from './grading.js';
export * from './digests.js';
export * from './ledger.js';
export * from './fan-in.js';
export * from './receipt/authorship.js';
export * from './receipt/statement.js';
export * from './receipt/dsse.js';
export * from './receipt/ai-bom.js';
export * from './receipt/project.js';
export * from './reproducibility.js';
export * from './compliance/citations.js';
